import { getDate } from '@/utils/date'
const data = {
    quanguo: {
        device_statistics: {
            total: 80011,
            online: 79803,
            offline: 208,
        },
        event_top: {
            xData: ['压力低限报警', '消防烟感告警', '传感器火警', '水位低限报警', '消防温度告警',],
            yData: [6, 5, 4, 2, 1]
        },
        alarm_week: {
            yData: [94, 115, 145, 133, 134, 148, 90]
        },
        today_count: {
            alarm: 29,
            pending: 5,
            processing: 19,
            processed: 5
        },
        project: {
            count: 23,
            device: 80011
        },
        monitor_count: {
            total: 1261,
            online: 458,
            offline: 803
        },
        wordOrder_count: {
            total: 45,
            pending: 7,
            processing: 9,
            receiving: 6,
            accomplish: 21,
            closed: 0
        },
        polling: {
            xData: ['天鹅湖花园', '锦绣四期', '纯水岸', '天鹅堡', '汉口道6号'],
            yData: [100, 100, 100, 100, 90]
        },
        fireControl: {
            total: 18
        },
        monitor_list: [
            {
                name: 'B3车库入口',
                src: require('../assets/B3车库入口.mp4')
            },
            {
                name: '儿童活动区球机',
                src: require('../assets/儿童活动区球机.mp4')
            },
            {
                name: '幼儿园后休闲通道',
                src: require('../assets/幼儿园后休闲通道.mp4')
            },
        ],
        workOrder_TableData: [
            {
                name: '园区巡逻任务',
                project: '华侨城原岸（武汉）',
                business: '公共区域安全管理',
                status: '处理中',
                businessType: '计划工单',
                planType: '人工',
                level: 'Ⅱ级',
                people: '施泉',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '道口岗位视频巡检',
                project: '华侨城原岸（武汉）',
                business: '公共区域安全管理',
                status: '处理中',
                businessType: '计划工单',
                planType: '视频',
                level: 'Ⅱ级',
                people: '王凯',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '1栋负一楼消防通道占用',
                project: '华侨城原岸（武汉）',
                business: '消防通道占用',
                status: '已完成',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅰ级',
                people: '施泉',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '地下二层停车场辆乱停',
                project: '华侨城原岸（武汉）',
                business: '车辆乱停',
                status: '待处理',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅱ级',
                people: '吴平平',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '1层消防烟感告警',
                project: '红坊营销中心',
                business: '消防烟感告警',
                status: '已完成',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅰ级',
                people: '张杰',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '北大门岗亭人员滞留',
                project: '万吨华中冷链港',
                business: '人员滞留',
                status: '处理中',
                businessType: '临时工单',
                planType: '人员',
                level: 'Ⅱ级',
                people: '王腾飞',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '地下一层停车场车辆乱停',
                project: '万吨华中冷链港',
                business: '车辆乱停',
                status: '处理中',
                businessType: '临时工单',
                planType: '人员',
                level: 'Ⅱ级',
                people: '周玉粉',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '高区供水水箱液位',
                project: '星河郡住宅项目',
                business: '水位低限报警',
                status: '已完成',
                businessType: '临时工单',
                planType: '人员',
                level: 'Ⅲ级',
                people: '刘利一',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: 'C栋8单元10层压力低限报警',
                project: '星河郡住宅项目',
                business: '压力低限报警',
                status: '处理中',
                businessType: '临时工单',
                planType: '人员',
                level: 'Ⅲ级',
                people: '刘利一',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: 'A栋03号电梯有电动车进入',
                project: '星河郡住宅项目',
                business: '电动车入电梯',
                status: '待处理',
                businessType: '计划工单',
                planType: '人员',
                level: 'Ⅱ级',
                people: '冯叶',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '配电室维保任务',
                project: '万吨华中冷链港',
                business: '公共区域安全管理',
                status: '处理中',
                businessType: '计划工单',
                planType: '人员',
                level: 'Ⅱ级',
                people: '张建中',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '道口岗位视频巡检',
                project: '汉口道6号',
                business: '公共区域安全管理',
                status: '处理中',
                businessType: '计划工单',
                planType: '视频',
                level: 'Ⅱ级',
                people: '游东',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: 'A栋5层消防烟感告警',
                project: '衡阳分公司五一小区',
                business: '消防烟感告警',
                status: '已完成',
                businessType: '临时工单',
                planType: '人员',
                level: 'Ⅰ级',
                people: '陈积忠',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`

            },
            {
                name: '小区配电房日常维保',
                project: '江霞向阳五一小区',
                business: '配电房日常维保',
                status: '已完成',
                businessType: '计划工单',
                planType: '人员',
                level: 'Ⅱ级',
                people: '李剑',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`

            },
            {
                name: '东门1栋地下停车场乱停',
                project: '衡阳华侨城创展中心',
                business: '车辆乱停',
                status: '已完成',
                businessType: '临时工单',
                planType: '人员',
                level: 'Ⅱ级',
                people: '李佳芊',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`

            },
            {
                name: '1栋7层压力低限报警',
                project: '原岸一期',
                business: '压力低限报警',
                status: '已完成',
                businessType: '临时工单',
                planType: '人员',
                level: 'Ⅲ级',
                people: '王娜',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`

            },
            {
                name: '1栋天面喷淋末端压力',
                project: '原岸一期',
                business: '压力低限报警',
                status: '已完成',
                businessType: '临时工单',
                planType: '人员',
                level: 'Ⅲ级',
                people: '段诗琪',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`

            },
            {
                name: '小区日常巡检任务',
                project: '衡阳分公司五一小区',
                business: '公共区域安全管理',
                status: '待接单',
                businessType: '计划工单',
                planType: '人员',
                level: 'Ⅱ级',
                people: '—',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`

            },
            {
                name: '道口岗位视频巡检',
                project: '江霞向阳五一小区',
                business: '公共区域安全管理',
                status: '待处理',
                businessType: '计划工单',
                planType: '视频',
                level: 'Ⅱ级',
                people: '李剑',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`

            },
            {
                name: '水泵房巡检',
                project: '友爱一期安置房',
                business: '水泵房巡检',
                status: '待接单',
                businessType: '计划工单',
                planType: '人员',
                level: 'Ⅱ级',
                people: '—',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`

            },
            {
                name: '道口岗位视频巡检',
                project: '天鹅湖花园',
                business: '公共区域安全管理',
                status: '待接单',
                businessType: '计划工单',
                planType: '视频',
                level: 'Ⅱ级',
                people: '—',
                isOvert未超时ime: '',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '大堂视频巡检',
                project: '天鹅湖花园',
                business: '公共区域安全管理',
                status: '处理中',
                businessType: '计划工单',
                planType: '视频',
                level: 'Ⅱ级',
                people: '杨豪',
                isOvertime未超时: '',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '发电机机房巡检',
                project: '天鹅湖花园',
                business: '发电机机房巡检',
                status: '处理中',
                businessType: '计划工单',
                planType: '人工',
                level: 'Ⅱ级',
                people: '张琪',
                isOvertime未超时: '',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '水泵房巡检',
                project: '天鹅湖花园',
                business: '水泵房巡检',
                status: '待接单',
                businessType: '计划工单',
                planType: '人工',
                level: 'Ⅱ级',
                people: '—',
                isOvert未超时ime: '',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '配电室巡检',
                project: '天鹅湖花园',
                business: '配电室巡检',
                status: '待接单',
                businessType: '计划工单',
                planType: '人工',
                level: 'Ⅱ级',
                people: '—',
                isOvert未超时ime: '',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '1栋负一楼设备房消防烟感告警',
                project: '香山美墅',
                business: '消防烟感告警',
                status: '已完成',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅰ级',
                people: '龙九烨',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '1栋8层消防楼梯通道占用',
                project: '香山美墅',
                business: '消防通道占用',
                status: '已完成',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅰ级',
                people: '龙九烨',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '2栋15层高空抛物',
                project: '香山美墅',
                business: '高空抛物',
                status: '已完成',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅰ级',
                people: '魏彬',
                isOvertime未超时: '',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '2栋3层压力低限报警',
                project: '香山美墅',
                business: '压力低限报警',
                status: '已完成',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅲ级',
                people: '张亚东',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '一期B1栋4层消防烟感告警',
                project: '天鹅湖花园',
                business: '消防烟感告警',
                status: '已完成',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅰ级',
                people: '黄建强',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '一期B2栋6层压力低限报警',
                project: '天鹅湖花园',
                business: '压力低限报警',
                status: '已完成',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅲ级',
                people: '张琪',
                isOvertime未超时: '',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '一期B1栋3层压力低限报警',
                project: '天鹅湖花园',
                business: '压力低限报警',
                status: '已完成',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅲ级',
                people: '张琪',
                isOvertime未超时: '',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '一号门西球机',
                project: '天鹅湖花园',
                business: '人员滞留',
                status: '已完成',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅱ级',
                people: '候建伟',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '一期B2栋天面喷淋末端压力',
                project: '天鹅湖花园',
                business: '压力低限报警',
                status: '已完成',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅲ级',
                people: '张琪',
                isOvertime未超时: '',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '15期3栋1单元消防温度告警',
                project: '纯水岸',
                business: '消防温度告警',
                status: '已完成',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅰ级',
                people: '左体荣',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: 'A栋2单元41层传感器火警',
                project: '锦绣四期',
                business: '传感器火警',
                status: '已完成',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅰ级',
                people: '程琪波',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: 'A栋1单元20层压力低限报警',
                project: '锦绣四期',
                business: '压力低限报警',
                status: '已完成',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅲ级',
                people: '程琪波',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '高区供水水箱液位',
                project: '天鹅堡',
                business: '水位低限报警',
                status: '处理中',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅲ级',
                people: '温多',
                isOvertime未超时: '',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: 'B栋11层A户型卧室传感器火警',
                project: '燕晗山苑',
                business: '传感器火警',
                status: '处理中',
                businessType: '临时工单',
                planType: '人工',
                level: 'Ⅰ级',
                people: '张祖锋',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '配电室巡检',
                project: '锦绣四期',
                business: '配电室巡检巡检',
                status: '待接单',
                businessType: '计划工单',
                planType: '人工',
                level: 'Ⅱ级',
                people: '—',
                isOvert未超时ime: '',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '水泵房巡检',
                project: '锦绣四期',
                business: '水泵房巡检',
                status: '待接单',
                businessType: '计划工单',
                planType: '人工',
                level: 'Ⅱ级',
                people: '—',
                isOvert未超时ime: '',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '发电机机房巡检',
                project: '纯水岸',
                business: '发电机机房巡检',
                status: '已完成',
                businessType: '计划工单',
                planType: '人工',
                level: 'Ⅱ级',
                people: '左体荣',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '配电室巡检',
                project: '天鹅堡',
                business: '配电室巡检',
                status: '待处理',
                businessType: '计划工单',
                planType: '人工',
                level: 'Ⅱ级',
                people: '刘亚松',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '道口岗位视频巡检',
                project: '天鹅湖花园',
                business: '公共区域安全管理',
                status: '待处理',
                businessType: '计划工单',
                planType: '人工',
                level: 'Ⅱ级',
                people: '杨豪',
                isOvertime未超时: '',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '发电机机房巡检',
                project: '纯水岸',
                business: '发电机机房巡检',
                status: '待处理',
                businessType: '计划工单',
                planType: '人工',
                level: 'Ⅱ级',
                people: '李传义',
                isOvertime: '未超时',
                closeType: '—',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            }
        ],
    },
    hubei: {
        device_statistics: {
            total: 22960,
            online: 22924,
            offline: 36,
        },
        event_top: {
            xData: ['压力低限报警', '消防烟感告警', '水位低限报警', '传感器火警', '消防温度告警',],
            yData: [2, 1, 1, 0, 0]
        },
        alarm_week: {
            yData: [43, 36, 48, 50, 37, 41, 33]
        },
        today_count: {
            alarm: 8,
            pending: 2,
            processing: 3,
            processed: 3
        },
        project: {
            count: 7,
            device: 22960
        },
        monitor_count: {
            total: 474,
            online: 427,
            offline: 47
        },
        wordOrder_count: {
            total: 12,
            pending: 2,
            processing: 7,
            receiving: 3,
            accomplish: 13,
            closed: 0
        },
        polling: {
            xData: ['华侨城原岸（武汉）', '汉口道6号'],
            yData: [100, 100]
        },
        fireControl: {
            total: 4
        },
        monitor_list: [
            {
                name: 'E2天台东',
                src: require('../assets/E2天台东.mp4')
            },
            {
                name: '二期负二停车位292',
                src: require('../assets/二期负二停车位292.mp4')
            },
            {
                name: '南北围栏5',
                src: require('../assets/南北围栏5.mp4')
            },
        ],
        workOrder_TableData: [
            {
                name: '园区巡逻任务',
                project: '华侨城原岸（武汉）',
                business: '公共区域安全管理',
                status: '处理中',

                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '道口岗位视频巡检',
                project: '华侨城原岸（武汉）',
                business: '公共区域安全管理',
                status: '处理中',

                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '1栋负一楼消防通道占用',
                project: '华侨城原岸（武汉）',
                business: '消防通道占用',
                status: '已完成',

                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '地下二层停车场辆乱停',
                project: '华侨城原岸（武汉）',
                business: '车辆乱停',
                status: '待处理',

                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '1层消防烟感告警',
                project: '红坊营销中心',
                business: '消防烟感告警',
                status: '已完成',

                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '北大门岗亭人员滞留',
                project: '万吨华中冷链港',
                business: '人员滞留',
                status: '处理中',

                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '地下一层停车场车辆乱停',
                project: '万吨华中冷链港',
                business: '车辆乱停',
                status: '处理中',

                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '高区供水水箱液位',
                project: '星河郡住宅项目',
                business: '水位低限报警',
                status: '已完成',

                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: 'C栋8单元10层压力低限报警',
                project: '星河郡住宅项目',
                business: '压力低限报警',
                status: '处理中',

                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: 'A栋03号电梯有电动车进入',
                project: '星河郡住宅项目',
                business: '电动车入电梯',
                status: '待处理',

                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '配电室维保任务',
                project: '万吨华中冷链港',
                business: '公共区域安全管理',
                status: '处理中',

                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '道口岗位视频巡检',
                project: '汉口道6号',
                business: '公共区域安全管理',
                status: '处理中',

                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
        ]
    },
    hunan: {
        device_statistics: {
            total: 4492,
            online: 4485,
            offline: 7,
        },
        event_top: {
            xData: ['压力低限报警', '消防烟感告警', '传感器火警', '水位低限报警', '消防温度告警',],
            yData: [2, 1, 0, 0, 0]
        },
        alarm_week: {
            yData: [44, 34, 36, 30, 38, 29, 27]
        },
        today_count: {
            alarm: 4,
            pending: 1,
            processing: 0,
            processed: 3
        },
        project: {
            count: 5,
            device: 4492
        },
        monitor_count: {
            total: 262,
            online: 234,
            offline: 28
        },
        wordOrder_count: {
            total: 8,
            pending: 2,
            processing: 0,
            receiving: 1,
            accomplish: 5,
            closed: 0
        },
        polling: {
            xData: ['衡阳分公司五一小区', '江霞向阳五一小区', '友爱一期安置房'],
            yData: [100, 100, 100]
        },
        fireControl: {
            total: 3
        },
        monitor_list: [
            {
                name: '二期负二停车位292',
                src: require('../assets/二期负二停车位292.mp4')
            },
            {
                name: '花园管理处拐弯楼梯口',
                src: require('../assets/花园管理处拐弯楼梯口.mp4')
            },
            {
                name: '应急小门往会所',
                src: require('../assets/应急小门往会所.mp4')
            }
        ],
        workOrder_TableData: [
            {
                name: 'A栋5层消防烟感告警',
                project: '衡阳分公司五一小区',
                business: '消防烟感告警',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`

            },
            {
                name: '小区配电房日常维保',
                project: '江霞向阳五一小区',
                business: '配电房日常维保',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`

            },
            {
                name: '东门1栋地下停车场乱停',
                project: '衡阳华侨城创展中心',
                business: '车辆乱停',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`

            },
            {
                name: '1栋7层压力低限报警',
                project: '原岸一期',
                business: '压力低限报警',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`

            },
            {
                name: '1栋天面喷淋末端压力',
                project: '原岸一期',
                business: '压力低限报警',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`

            },
            {
                name: '小区日常巡检任务',
                project: '衡阳分公司五一小区',
                business: '公共区域安全管理',
                status: '待接单',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`

            },
            {
                name: '道口岗位视频巡检',
                project: '江霞向阳五一小区',
                business: '公共区域安全管理',
                status: '待处理',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`

            },
            {
                name: '水泵房巡检',
                project: '友爱一期安置房',
                business: '水泵房巡检',
                status: '待接单',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`

            }
        ]

    },
    guangdong: {
        device_statistics: {
            total: 52559,
            online: 52394,
            offline: 165,
        },
        event_top: {
            xData: ['压力低限报警', '消防烟感告警', '传感器火警', '水位低限报警', '消防温度告警',],
            yData: [4, 2, 2, 2, 1]
        },
        alarm_week: {
            yData: [39, 40, 36, 43, 39, 50, 42]
        },
        today_count: {
            alarm: 17,
            pending: 2,
            processing: 13,
            processed: 2
        },
        project: {
            count: 11,
            device: 52559
        },
        monitor_count: {
            total: 525,
            online: 458,
            offline: 67
        },
        wordOrder_count: {
            total: 25,
            pending: 5,
            processing: 2,
            receiving: 3,
            accomplish: 13,
            closed: 0
        },
        polling: {
            xData: ['天鹅湖花园', '锦绣四期', '纯水岸', '天鹅堡'],
            yData: [95, 100, 100, 100]
        },
        fireControl: {
            total: 11,
            smokeDetector: 45,
            sensor: 62,
            temperature: 75,
            other: 83
        },
        monitor_list: [
            {
                name: 'E栋广场北面通道',
                src: require('../assets/E栋广场北面通道.mp4')
            },
            {
                name: '花园休息处平台',
                src: require('../assets/花园休息处平台.mp4')
            },
            {
                name: '旋转楼梯球机',
                src: require('../assets/旋转楼梯球机.mp4')
            },
        ],
        workOrder_TableData: [
            {
                name: '道口岗位视频巡检',
                project: '天鹅湖花园',
                business: '公共区域安全管理',
                status: '待接单',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '大堂视频巡检',
                project: '天鹅湖花园',
                business: '公共区域安全管理',
                status: '处理中',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '发电机机房巡检',
                project: '天鹅湖花园',
                business: '发电机机房巡检',
                status: '处理中',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '水泵房巡检',
                project: '天鹅湖花园',
                business: '水泵房巡检',
                status: '待接单',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '配电室巡检',
                project: '天鹅湖花园',
                business: '配电室巡检',
                status: '待接单',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '1栋负一楼设备房消防烟感告警',
                project: '香山美墅',
                business: '消防烟感告警',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '1栋8层消防楼梯通道占用',
                project: '香山美墅',
                business: '消防通道占用',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '2栋15层高空抛物',
                project: '香山美墅',
                business: '高空抛物',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '2栋3层压力低限报警',
                project: '香山美墅',
                business: '压力低限报警',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '一期B1栋4层消防烟感告警',
                project: '天鹅湖花园',
                business: '消防烟感告警',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '一期B2栋6层压力低限报警',
                project: '天鹅湖花园',
                business: '压力低限报警',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '一期B1栋3层压力低限报警',
                project: '天鹅湖花园',
                business: '压力低限报警',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '一号门西球机',
                project: '天鹅湖花园',
                business: '人员滞留',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '一期B2栋天面喷淋末端压力',
                project: '天鹅湖花园',
                business: '压力低限报警',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '15期3栋1单元消防温度告警',
                project: '纯水岸',
                business: '消防温度告警',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: 'A栋2单元41层传感器火警',
                project: '锦绣四期',
                business: '传感器火警',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: 'A栋1单元20层压力低限报警',
                project: '锦绣四期',
                business: '压力低限报警',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '高区供水水箱液位',
                project: '天鹅堡',
                business: '水位低限报警',
                status: '处理中',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: 'B栋11层A户型卧室传感器火警',
                project: '燕晗山苑',
                business: '传感器火警',
                status: '处理中',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '配电室巡检',
                project: '锦绣四期',
                business: '配电室巡检巡检',
                status: '待接单',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '水泵房巡检',
                project: '锦绣四期',
                business: '水泵房巡检',
                status: '待接单',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '发电机机房巡检',
                project: '纯水岸',
                business: '发电机机房巡检',
                status: '已完成',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '配电室巡检',
                project: '天鹅堡',
                business: '配电室巡检',
                status: '待处理',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '道口岗位视频巡检',
                project: '天鹅湖花园',
                business: '公共区域安全管理',
                status: '待处理',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            },
            {
                name: '发电机机房巡检',
                project: '纯水岸',
                business: '发电机机房巡检',
                status: '待处理',
                date: `${getDate().date} 0${Math.floor(Math.random() * (8 - 0 + 1)) + 0}:${Math.floor(Math.random() * (59 - 10 + 1)) + 10}:00`
            }
        ]
    },
    // other: {
    //     device_statistics: {
    //         total: 0,
    //         online: 0,
    //         offline: 0,
    //     },
    //     event_top: {
    //         xData: [],
    //         yData: []
    //     },
    //     alarm_week: {
    //         yData: []
    //     },
    //     today_count: {
    //         alarm: 0,
    //         pending: 0,
    //         processing: 0,
    //         processed: 0
    //     },
    //     project: {
    //         count: 0,
    //         device: 0
    //     },
    //     monitor_count: {
    //         total: 0,
    //         online: 0,
    //         offline: 0
    //     },
    //     wordOrder_count: {
    //         total: 0,
    //         pending: 0,
    //         processing: 0
    //     },
    //     polling: {
    //         xData: [],
    //         yData: []
    //     },
    //     fireControl: {
    //         total: 0,
    //     },
    //     monitor_list: [],
    //     workOrder_TableData: []
    // },
}

export default data